import { createAction, createAsyncAction } from "typesafe-actions";
import * as T from "./types";

export const setSidebarCollapsed = createAction("INTERNAL_SET_SIDEBAR_COLLAPSED")<boolean>();

export const setPresentMode = createAction("INTERNAL_SET_PRESENT_MODE")<boolean>();

export const setFullScreen = createAction("INTERNAL_SET_FULL_SCREEN")<boolean>();

export const updateExchange = createAction("UPDATE_EXCHANGE_INTERNAL")<string>();

export const fetchTickers = createAsyncAction(
  "FETCH_TICKERS_REQUEST",
  "FETCH_TICKERS_SUCCESS",
  "FETCH_TICKERS_FAILURE"
)<string, T.Tickers[], void>();